export const ranges = [
  {
    name: 'desert eagle',
    range: 0.85,
    reward: 300,
  },
  {
    name: 'glock-18',
    range: 0.85,
    reward: 300,
  },
  {
    name: 'p90',
    range: 0.86,
    reward: 300,
  },
  {
    name: 'r8-revolver',
    range: 0.94,
    reward: 300,
  },
  {
    name: 'five-seven',
    range: 0.81,
    reward: 300,
  },
  {
    name: 'p2000',
    range: 0.91,
    reward: 300,
  },
  {
    name: 'ak-47',
    range: 0.98,
    reward: 300,
  },
  {
    name: 'awp',
    range: 0.99,
    reward: 100,
  },
  {
    name: 'm4a1-s',
    range: 0.99,
    reward: 300,
  },
  {
    name: 'm4a4',
    range: 0.97,
    reward: 300,
  },
  {
    name: 'sawed-off',
    range: 0.45,
    reward: 900,
  },
  {
    name: 'mp9',
    range: 0.87,
    reward: 900,
  },
  {
    name: 'usp-s',
    range: 0.91,
    reward: 300,
  },
  {
    name: 'nova',
    range: 0.7,
    reward: 900,
  },
  {
    name: 'mac-10',
    range: 0.8,
    reward: 600,
  },
  {
    name: 'g3sg1',
    range: 0.98,
    reward: 300,
  },
  {
    name: 'scar-20',
    range: 0.98,
    reward: 300,
  },
  {
    name: 'mag-7',
    range: 0.45,
    reward: 900,
  },
  {
    name: 'mp5-sd',
    range: 0.85,
    reward: 600,
  },
  {
    name: 'xm1014',
    range: 0.7,
    reward: 900,
  },
  {
    name: 'ssg-08',
    range: 0.98,
    reward: 300,
  },
  {
    name: 'famas',
    range: 0.96,
    reward: 300,
  },
  {
    name: 'p250',
    range: 0.9,
    reward: 300,
  },
  {
    name: 'tec-9',
    range: 0.79,
    reward: 300,
  },
  {
    name: 'cz75-auto',
    range: 0.85,
    reward: 100,
  },
  {
    name: 'dual berettas',
    range: 0.79,
    reward: 300,
  },
  {
    name: 'pp-bizon',
    range: 0.8,
    reward: 600,
  },
  {
    name: 'mp7',
    range: 0.85,
    reward: 600,
  },
  {
    name: 'ump-45',
    range: 0.75,
    reward: 600,
  },
  {
    name: 'aug',
    range: 0.98,
    reward: 300,
  },
  {
    name: 'galil-ar',
    range: 0.98,
    reward: 300,
  },
  {
    name: 'm249',
    range: 0.97,
    reward: 300,
  },
  {
    name: 'negev',
    range: 0.97,
    reward: 300,
  },
  {
    name: 'sg-553',
    range: 0.98,
    reward: 300,
  },
];
